import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { type ThunkDispatch, type UnknownAction } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { useCurrentUser } from 'FrontRoyalAngular';
import { type CareerProfile } from 'CareerProfiles';
import { openChatAndSelectUser } from 'Messaging';

function canSendbird(
    currentUser: { messagingEnabled?: boolean; sendbirdAccessToken?: string | null } | null,
    profile: CareerProfile,
) {
    return (
        !!currentUser?.messagingEnabled &&
        !!currentUser?.sendbirdAccessToken &&
        !!profile.messagingEnabled &&
        !!profile.hasSendbirdAccessToken
    );
}

export function useMessageUser() {
    const dispatch = useDispatch<ThunkDispatch<unknown, unknown, UnknownAction>>();
    const navigate = useNavigate();
    const currentUser = useCurrentUser();
    const [contactFormProfile, setContactFormProfile] = useState<CareerProfile | null>(null);

    const handleMessage = useCallback(
        (profile: CareerProfile) => {
            if (canSendbird(currentUser, profile)) {
                dispatch(
                    openChatAndSelectUser({
                        currentUserId: currentUser!.id,
                        token: currentUser!.sendbirdAccessToken!,
                        userToMessageId: profile.userId,
                    }),
                ).then(() => {
                    navigate('/student-network/messages');
                });
            } else {
                setContactFormProfile(profile);
            }
        },
        [currentUser, dispatch, navigate],
    );

    const closeContactForm = useCallback(() => setContactFormProfile(null), []);

    return { handleMessage, contactFormProfile, closeContactForm };
}
